import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { track } from '@amplitude/analytics-browser';

import { AmplitudeEvents } from '@utils/amplitudeEvents';
import {
	PerformRepaymentResponse,
	QRRepayment,
	URLRepayment,
} from '../../../types/generated/pos';

type PaymentRedirectParams = {
	accountId: string | number;
	providerCode: string;
};

export const usePaymentRedirect = (
	paymentResponse: PerformRepaymentResponse | null | undefined,
	params: PaymentRedirectParams
) => {
	const navigate = useNavigate();

	useEffect(() => {
		if (!paymentResponse?.paymentData) {
			return;
		}

		const { paymentData } = paymentResponse;

		if (paymentData.type === 'URL') {
			const urlData = paymentData as URLRepayment;
			track(AmplitudeEvents.Redirect_Opened, { url: urlData.paymentUrl });
			window.open(urlData.paymentUrl, '_self');
			return;
		}

		if (paymentData.type === 'QR') {
			const qrData = paymentData as QRRepayment;
			navigate(`/qrRepayment/${params.accountId}`, {
				state: {
					qrData,
					providerCode: params.providerCode,
				},
			});
			return;
		}
	}, [paymentResponse, navigate, params.accountId, params.providerCode]);
};
